var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowForwardIos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 29,
    viewBox: "0 0 16 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.06445 1.06451C1.65024 0.47872 2.60376 0.474951 3.18955 1.06074L15.5489 13.4201C16.1347 14.0059 16.1347 14.9556 15.5489 15.5414L3.18955 27.9008C2.60376 28.4865 1.65024 28.4828 1.06445 27.897C0.478655 27.3112 0.474894 26.3577 1.0607 25.7719L11.2915 15.5414C11.8773 14.9556 11.8773 14.0059 11.2915 13.4201L1.0607 3.18962C0.474894 2.60384 0.478655 1.6503 1.06445 1.06451Z",
    fill: "#A2C357"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForwardIos);
export default __webpack_public_path__ + "static/media/arrow_forward_ios.56651118dcf83fa15709253a42bc1d67.svg";
export { ForwardRef as ReactComponent };